import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Card, Form, Row } from 'antd';
import { notification } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';

import FormField from '@/components/FormField';
import biFormFields from '@/config/programs/biFormFields';
import biFormTitles from '@/config/programs/biFormTitles';
import useGlobalConfig from '@/store/global';

const BiRequest = () => {
  const [toast, contextHolder] = notification.useNotification();
  const { program, themeColor } = useGlobalConfig();
  const [loading, setLoading] = useState(false);
  const cardRef = useRef<any>(null);

  const [form] = Form.useForm();

  const navigate = useNavigate();

  const formFields = biFormFields[program?.name as keyof typeof biFormFields];

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          setLoading(true);

          const formData = new FormData();
          Object.keys(values).forEach((key) => {
            // if (key === "signed_pdf_file" || key === "insurance_card") {
            if (key === 'insurance_card') {
              const fileList = values[key];
              if (fileList?.[0]?.originFileObj) {
                formData.append(key, fileList[0].originFileObj);
              }
            } else if (key === 'licensed_prescriber_signature_date') {
              formData.append(key, dayjs(new Date()).format('YYYY-MM-DD'));
              // } else if (key === "patient_signature_date") {
              // formData.append(key, dayjs(new Date()).format("YYYY-MM-DD"));
            } else if (key === 'patient_dob') {
              formData.append(key, dayjs(new Date(values[key])).format('YYYY-MM-DD'));
            } else if (key === 'prescription_is_used') {
              formData.append(key, values[key] === true ? 'true' : 'false');
            } else {
              formData.append(key, values[key]);
            }
          });

          await axios.post(`/benefit_investigation_requests`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          toast.success({
            message: 'Request submitted successfully',
            description: 'Your request has been submitted successfully',
          });
          form.resetFields();
          navigate(-1);
        } catch (error) {
          toast.error({
            message: 'Request submission failed',
            description: 'Please try again',
          });
          console.error(error);
        } finally {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log('error: ', error);
      });
  };

  useEffect(() => {
    form.setFieldValue('licensed_prescriber_signature_date', dayjs());
  }, []);

  return (
    <>
      {contextHolder}
      <Card className="my-10 bg-white print:my-0 print:border-none print:p-0">
        <Form form={form} onFinish={handleSubmit} layout="vertical" className="mt-10 bg-white">
          <div className="" ref={cardRef}>
            <h3
              className="mb-10 border-b pb-6 text-center text-xl md:text-3xl font-bold text-[#284095]"
              style={{ color: themeColor }}
            >
              {biFormTitles[program?.name as keyof typeof biFormTitles] || ''}
            </h3>

            {formFields.map((section) => (
              <div>
                <div
                  className="bg-[#20419b] px-2 text-xl font-semibold uppercase text-white"
                  style={{ backgroundColor: themeColor }}
                >
                  {section.title}
                </div>
                <Row gutter={[16, 0]} className="mt-4">
                  {section.fields.map((field) => (
                    <FormField key={field.name} field={field} />
                  ))}
                </Row>
              </div>
            ))}
          </div>
          <div className="mt-10 grid grid-cols-7 gap-4 print:hidden">
            <Button
              className="col-span-3 col-start-3 w-full"
              type="primary"
              size="large"
              disabled={loading}
              loading={loading}
              onClick={handleSubmit}
              style={{
                backgroundColor: themeColor,
              }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default BiRequest;
